<template>
    <div>
        <svg ref='barcode' />
    </div>
</template>

<script>
    import { loadScript } from '@superbet-group/web.lib.utilities';
    import Vue from 'vue';

    import { errorGuard } from '@utils/ErrorGuard';

    export default Vue.component('Barcode', {
        props: {
            text: {
                type: String,
                required: true,
            },
            height: {
                type: Number,
                required: false,
                default: 32,
            },
        },
        data() {
            return {
                isScriptLoaded: false,
            };
        },
        async created() {
            const url = `${window.location.origin}/static/js/JsBarcode.code.128.min.js`;
            await loadScript(url, 'barcode');
            this.isScriptLoaded = true;
        },
        watch: {
            isScriptLoaded(newValue, oldValue) {
                if (newValue && !oldValue) {
                    this.generate();
                }
            },
        },
        methods: {
            generate() {
                if (this.$el) {
                    errorGuard(() => window.JsBarcode(this.$refs.barcode, this.text, {
                        displayValue: false,
                        height: this.height,
                        width: 2,
                        margin: 0,
                        padding: 0,
                    }), {
                        showGlobalError: false,
                    });
                }
            },
        },
    });
</script>
